const CACHE_PREFIX = 'consentdata:session-cache:v1:';

const stableSerialize = (value) => {
  if (Array.isArray(value)) return `[${value.map(stableSerialize).join(',')}]`;
  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort().map(key => `${JSON.stringify(key)}:${stableSerialize(value[key])}`).join(',')}}`;
  }
  return JSON.stringify(value);
};

export const createSessionCacheKey = (name, user, details = {}) => {
  let storedUser = null;
  try {
    storedUser = JSON.parse(sessionStorage.getItem('user') || localStorage.getItem('user') || 'null');
  } catch (error) {
    console.warn('Unable to read current user for session cache scoping', error);
  }

  const currentUser = { ...(storedUser || {}), ...(user || {}) };
  const tenantId = currentUser.tenant_id || currentUser.tenantId || localStorage.getItem('tenant_id') || '0';
  const identity = currentUser.id || currentUser.user_id || currentUser.email || 'anonymous';
  const role = currentUser.role || 'unknown';
  return `${CACHE_PREFIX}${encodeURIComponent(name)}:${encodeURIComponent(String(tenantId))}:${encodeURIComponent(String(role))}:${encodeURIComponent(String(identity))}:${encodeURIComponent(stableSerialize(details))}`;
};

export const readSessionCache = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const cached = JSON.parse(raw);
    return cached && cached.version === 1 ? cached.data : null;
  } catch (error) {
    console.warn('Unable to read cached page data', error);
    return null;
  }
};

export const writeSessionCache = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify({ version: 1, savedAt: Date.now(), data }));
    return true;
  } catch (error) {
    console.warn('Unable to cache page data; loading it from the server instead', error);
    return false;
  }
};

export const clearSessionCache = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.warn('Unable to clear cached page data', error);
  }
};

export const clearSessionCacheByPrefix = (prefix = CACHE_PREFIX) => {
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(prefix)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach(k => sessionStorage.removeItem(k));
  } catch (error) {
    console.warn('Unable to clear session cache by prefix', error);
  }
};

export const clearAllSessionCache = () => {
  clearSessionCacheByPrefix(CACHE_PREFIX);
};
